export default __webpack_public_path__ + "static/media/sv.3186524c.svg";